import { BASE_PATH } from '@shared/config/public';

export type SearchPageUrlParams = {
  destination: string;
  originCode: string;
  departureDate: string;
  returnDate: string;
  adults: string;
  children: string;
  infants: string;
};

export const goToSearchPage = async (params: SearchPageUrlParams) => {
  const searchParams = new URLSearchParams(params);

  window.location.assign(
    `${BASE_PATH ?? ''}/search/list?${searchParams.toString()}`,
  );

  return;
};
